<template>
  <div class="waper-box">
    <div id="user-box">
      <el-tabs type="border-card">
        <el-tab-pane>
          <span slot="label"><i class="el-icon-s-claim"></i>箱号管理</span>
          <div class="user-box-pub">
            <Boxnumber></Boxnumber>
          </div>
          </el-tab-pane>
        <!-- <el-tab-pane>
          <span slot="label"><i class="el-icon-s-promotion"></i>信息推送</span>
          <div class="user-box-pub">
            <Pushemail></Pushemail>
          </div>
        </el-tab-pane> -->
        <el-tab-pane>
          <span slot="label"><i class="el-icon-s-custom"></i>账号信息</span>
          <div class="user-box-pub">
            <Personal></Personal>
          </div>
        </el-tab-pane>
<!--        <el-tab-pane>-->
<!--          <span slot="label"><i class="el-icon-s-finance"></i>充值购买</span>-->
<!--          <div class="user-box-pub">-->
<!--            <UserPay></UserPay>-->
<!--          </div>-->
<!--        </el-tab-pane>-->
      </el-tabs>
    </div>
    <div class="whiteBox"></div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "../global/footer";
import Boxnumber from "./box_number"; //箱号管理
import Pushemail from "./mail_tui.vue"; //信息推送
import Personal from "./personal_user.vue"; //个人信息
import UserPay from "./user_pay.vue" //充值信息
export default {
  name: "User",
  data() {
    return {
      lftMenu: "min-height:800px",
      onindex: "1",
      userMenu: [
        {
          id: "1",
          path: "/Boxnumber",
          txt: "箱号管理",
        },
        // {
        //   id: "2",
        //   path: "/Casestatis",
        //   txt: "箱柜统计",
        // },
        {
          id: "2",
          path: "/Pushemail",
          txt: "信息推送",
        },
      ],
      compMenu: [
        {
          id: "1",
          path: "/Personal",
          txt: "公司信息",
        },
        // {
        //   id: "2",
        //   path: "/Passuser",
        //   txt: "修改密码",
        // },
      ],
    };
  },
  methods: {
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
  },
  computed: {},
  components: {
    Boxnumber,
    Pushemail,
    Personal,
    UserPay,
    Footer
  },
};
</script>

<style>
  .el-tabs__item {
    font-size: 15px !important;
  }

  .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
    border-bottom: none !important;
  }

  .el-submenu.is-active .el-submenu__title {
    border-bottom: none !important;
  }

  .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title {
    color: #303133 !important;
  }
</style>

<style scoped>
@import "./coms/user.css";
</style>



// WEBPACK FOOTER //
// src/components/user/user.vue